import { lazy, Suspense, type ComponentProps } from "react";

const Calendar = lazy(() =>
  import("./calendar").then((m) => ({ default: m.Calendar })),
);

export function LazyCalendar(props: ComponentProps<typeof Calendar>) {
  return (
    <Suspense
      fallback={
        <div
          className="p-3 text-sm text-muted-foreground"
          style={{ minWidth: 240, minHeight: 280 }}
        >
          Loading calendar…
        </div>
      }
    >
      <Calendar {...props} />
    </Suspense>
  );
}
